/* eslint-disable */
/* Code generated by generator.ts DO NOT EDIT. */
// Generated: 04-11-2026 08:35:03

export enum CohortrendementTotWaarde {
    ZONDER_VERTRAGING = "Zonder vertraging",
    ZONDER_VERTRAGING_PROGNOSE = "Zonder vertraging (prognose)",
    BOVEN_ADVIES = "Boven advies",
    BOVEN_ADVIES_PROGNOSE = "Boven advies (prognose)",
    ONDER_ADVIES = "Onder advies",
    ONDER_ADVIES_PROGNOSE = "Onder advies (prognose)",
    ONDER_ADVIES_GEDOUBLEERD = "Onder advies & gedoubleerd",
    ONDER_ADVIES_GEDOUBLEERD_PROGNOSE = "Onder advies & gedoubleerd (prognose)",
    GEDOUBLEERD = "Gedoubleerd",
    GEDOUBLEERD_PROGNOSE = "Gedoubleerd (prognose)",
    BOVEN_ADVIES_GEDOUBLEERD = "Boven advies & gedoubleerd",
    BOVEN_ADVIES_GEDOUBLEERD_PROGNOSE = "Boven advies & gedoubleerd (prognose)",
    AFGEWEZEN = "Afgewezen",
    AFGEWEZEN_PROGNOSE = "Afgewezen (prognose)"
}
